import { useEffect, useState } from "react";
import { History, Star } from "lucide-react";
import api from "../../lib/api";

// The member's own lookup history (newest first, deduped server-side). Shown inside the search card while the search box is empty.
export function RecentDepartments({ onOpen, refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/departments/recent").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, [refreshKey]);
  return (
    <div data-testid="recent-departments">
      <p className="px-4 pt-3 text-[11px] font-bold uppercase tracking-wider text-slate-500 inline-flex items-center gap-1.5"><History className="w-3.5 h-3.5 text-primary" /> Recently viewed</p>
      {items === null ? null : items.length === 0 ? (
        <p className="px-4 pb-4 pt-2 text-sm text-slate-500" data-testid="recent-empty">Departments you open will show up here, newest first. Type above to search the full directory.</p>
      ) : (
        <ul className="mt-1 divide-y divide-slate-100">
          {items.map((d) => (
            <li key={d.id}>
              <button type="button" onClick={() => onOpen(d.id)} className="w-full flex items-center gap-2 px-4 py-2.5 text-left hover:bg-slate-50" data-testid={`recent-dept-${d.id}`}>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-semibold text-slate-900 truncate">{d.name}</span>
                  <span className="block text-[11px] text-slate-500 truncate">{[d.city, d.state].filter(Boolean).join(", ")}</span>
                </span>
                {d.owned ? <span className="text-[10px] font-bold uppercase tracking-wider text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded shrink-0">Yours</span>
                  : d.researched ? <span className="text-[10px] font-bold uppercase tracking-wider text-primary bg-primary/10 px-1.5 py-0.5 rounded shrink-0">Researched</span>
                  : <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded shrink-0">Not researched</span>}
                {d.favorite && <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500 shrink-0" aria-label="Favorite" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
